import { Box } from '@mui/material';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ControlledField } from 'src/components/controlled-field';
import { FieldTypes } from 'src/components/controlled-field/types';
import { UserDetailsPartial } from 'src/auth/types';

import { AuthContext } from '../../providers/auth-context';

import { userDataKeys } from './constants';
import { styles } from './styles';

import type { UserDetailsProps, UserDataFormValues } from './types';

export const UserDetails: FC<UserDetailsProps<UserDataFormValues>> = ({ control }) => {
    const { t } = useTranslation();
    const userState = useContext(AuthContext);

    const userDetails = userState.session?.user.user_metadata as UserDetailsPartial;

    const disableImmutableFields = userState.loggedIn;

    return (
        <Box css={styles.userDetailsContainer}>
            <Box css={styles.inputGroupWrapper}>
                <ControlledField
                    name={userDataKeys.firstName}
                    control={control}
                    label={t('your_details_form_first_name_label')}
                    placeholder={t('your_details_form_first_name_placeholder')}
                    type="text"
                    disabled={disableImmutableFields}
                    id="user-details-first-name"
                />
                <ControlledField
                    name={userDataKeys.lastName}
                    control={control}
                    type="text"
                    label={t('your_details_form_last_name_label')}
                    placeholder={t('your_details_form_last_name_placeholder')}
                    disabled={disableImmutableFields}
                    id="user-details-last-name"
                />
            </Box>
            <ControlledField
                type="text"
                name={userDataKeys.preferredName}
                control={control}
                label={t('your_details_form_preferred_name_label')}
                placeholder={t('your_details_form_preferred_name_placeholder')}
                required={false}
                id="user-details-preferred-name"
            />
            {userState.loggedIn && (
                <ControlledField
                    type="email"
                    name={userDataKeys.email}
                    control={control}
                    label={t('your_details_form_email_label')}
                    placeholder={t('your_details_form_email_placeholder')}
                    disabled
                    id="user-details-email"
                />
            )}

            <ControlledField
                fieldType={FieldTypes.Phone}
                name={userDataKeys.phone}
                control={control}
                disabled={Boolean(
                    userState.loggedIn &&
                        userDetails?.phone &&
                        typeof userDetails.phone === 'object'
                )}
                label={t('your_details_form_phone_label')}
                id="user-details-phone"
            />
            <ControlledField
                fieldType={FieldTypes.DateOfBirth}
                name={userDataKeys.dateOfBirth}
                control={control}
                label={t('your_details_form_date_of_birth_label')}
                id="user-details-dob"
            />
        </Box>
    );
};
